// src/brand/favicons.ts
export function setFavicons(brand: string, themeColor?: string) {
  const base = `/brand/${brand}`
  
  // Helper pro upsert elementů
  const upsert = (tag: 'link' | 'meta', attrs: Record<string, string>, selector?: string) => {
    // Pokud existuje selector, zkusíme najít existující element
    let el = selector ? document.head.querySelector(selector) : null
    if (!el) {
      el = document.head.appendChild(document.createElement(tag))
    }
    Object.entries(attrs).forEach(([k, v]) => el!.setAttribute(k, v))
  }

  // Favicon - jeden společný pro všechny brandy
  upsert('link', { rel: 'icon', href: '/favicon.ico' }, 'link[rel="icon"]')

  // Manifest - použij manifest z příslušného brand adresáře
  upsert('link', { rel: 'manifest', href: `${base}/manifest.webmanifest` }, 'link[rel="manifest"]')

  // Apple touch icon
  upsert('link', { rel: 'apple-touch-icon', href: `${base}/apple-touch-icon.png` })
  
  // Safari pinned tab
  upsert('link', { rel: 'mask-icon', href: `${base}/safari-pinned-tab.svg`, color: themeColor ?? '#4DBA87' })
  
  // Theme color
  upsert('meta', { name: 'theme-color', content: themeColor ?? '#4DBA87' }, 'meta[name="theme-color"]')

  // Title podle brandu
  const title = brand === 'modernhockey' ? 'Modern Hockey' : 'Hockeybook'
  document.title = title
}
